var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('OnValidationList',{attrs:{"fss":_vm.fss,"rliss":_vm.rliss}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }